export default "__VITE_ASSET__Btd_6sde__";